import SingleChoiceQuestionPage from '@app-studio-web/ui/pages/SingleChoiceQuestionPage'
import { AnswerType } from '@app-studio-web/ui/types'

const answers: AnswerType[] = [
  {
    emoji: '🌱',
    title: 'pages.onboarding.streakQuestion.answer1',
    subtitle: 'pages.onboarding.streakQuestion.answer1Subtitle',
  },
  {
    emoji: '🔥',
    title: 'pages.onboarding.streakQuestion.answer2',
    subtitle: 'pages.onboarding.streakQuestion.answer2Subtitle',
  },
  {
    emoji: '💎',
    title: 'pages.onboarding.streakQuestion.answer3',
    subtitle: 'pages.onboarding.streakQuestion.answer3Subtitle',
  },
  {
    emoji: '👑',
    title: 'pages.onboarding.streakQuestion.answer4',
    subtitle: 'pages.onboarding.streakQuestion.answer4Subtitle',
  },
]

export default function StreakQuestionPage() {
  return (
    <SingleChoiceQuestionPage
      answers={answers}
      subtitle="pages.onboarding.streakQuestion.subtitle"
      title="pages.onboarding.streakQuestion.title"
    />
  )
}
